import { BackendResponseFormat } from "../utils/fetch";
import { BackendError } from "./BackendError";

export class ConflictError extends BackendError {
  constructor(responseBody: BackendResponseFormat<unknown> | string) {
    super(409, responseBody);
    this.name = "ConflictError";
  }
}
